import { colours } from "@shared/ui.design-system"

export const getColour = (colour = "white"): string => {
  const colourMap = {
    pink: colours.accent.strong,
    "light pink": colours.accent.soft,
    "lightest pink": colours.accent.light,
    white: colours.secondary.light,
    yellow: colours.warning.medium,
    gray: colours.secondary.warm,
  }
  return colourMap[colour.toLowerCase()]
}
